import { render, staticRenderFns } from "./RodapeSelo.vue?vue&type=template&id=c042718a&scoped=true"
import script from "./RodapeSelo.vue?vue&type=script&lang=js"
export * from "./RodapeSelo.vue?vue&type=script&lang=js"
import style0 from "./RodapeSelo.vue?vue&type=style&index=0&id=c042718a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c042718a",
  null
  
)

export default component.exports